module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cw-menu-header">\r\n    <div class="d-flex align-items-center" style="flex-direction: row; justify-content: space-around;">\r\n        <div id="cw-logo" role="banner" tabindex="0"></div>\r\n        <div class="phx-zone-selector cw-zone-selector"></div>\r\n    </div>\r\n    <span class="cw-menu-header-border"></span>\r\n</div>\r\n<div class="cw-menu-body d-flex align-items-top">\r\n    <div id="cw-menu-bar" class="d-flex flex-column">\r\n\r\n    </div>\r\n</div>\r\n<div class="cw-menu-bottom d-flex align-items-top">\r\n\r\n</div>';
}
return __p;
};
